export function ModalCross() {
  return (
  <svg viewBox="0 0 33 33" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M32.915 1.085c.599.6.599 1.571 0 2.17L19.17 17l13.745 13.744a1.535 1.535 0 01-2.17 2.17L17 19.17 3.255 32.915a1.535 1.535 0 01-2.17-2.17L14.83 17 1.085 3.255a1.535 1.535 0 112.17-2.17L17 14.83 30.744 1.085c.6-.6 1.572-.6 2.17 0z" fill="currentColor"></path>
  </svg>
  );
}